import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onMounted } from 'vue'
import ActionButton from '@/components/ui/ActionButton.vue'
import { adminEfpImpersonationStatus } from '@/api/adminEfp'
import { useAdminEfpStore } from '@/stores/adminEfp'
import { useAuthStore } from '@/stores/auth'

interface Props {
  selectedCount: number
}

interface Emits {
  (e: 'link-colors-selected'): void
  (e: 'delink-colors-selected'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCouleurLieeDelier',
  props: {
    selectedCount: {}
  },
  emits: ["link-colors-selected", "delink-colors-selected"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const adminEfpStore = useAdminEfpStore()
const authStore = useAuthStore()

const isAdminEfp = computed(
  () => adminEfpStore.isAdminEfpValidated || authStore.isImpersonating,
)

const buttonTitle = computed(() =>
  props.selectedCount === 0
    ? 'Sélectionnez des produits pour activer cette action'
    : undefined,
)

onMounted(async () => {
  if (isAdminEfp.value) return
  try {
    const status = await adminEfpImpersonationStatus()
    authStore.setImpersonationFromCookie(
      status.active,
      status.adminDisplayName ?? undefined,
    )
  } catch {
    authStore.setImpersonationFromCookie(false)
  }
})

const handleLinkColors = () => {
  if (!props.selectedCount) return
  emit('link-colors-selected')
}

const handleDelinkColors = () => {
  if (!props.selectedCount) return
  emit('delink-colors-selected')
}

return (_ctx: any,_cache: any) => {
  return (isAdminEfp.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(ActionButton, {
          label: "Couleur liée",
          variant: "info",
          onClick: handleLinkColors,
          disabled: _ctx.selectedCount === 0,
          title: buttonTitle.value,
          size: "sm",
          customClass: "!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
        }, null, 8, ["disabled", "title"]),
        _createVNode(ActionButton, {
          label: "Couleur déliée",
          variant: "modifier",
          onClick: handleDelinkColors,
          disabled: _ctx.selectedCount === 0,
          showIcon: false,
          title: buttonTitle.value,
          size: "sm",
          customClass: "!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
        }, null, 8, ["disabled", "title"])
      ], 64))
    : _createCommentVNode("", true)
}
}

})